module.exports = __webpack_public_path__ + "img/facebookicon.014788b8.svg";